import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Col, Container, Row } from 'reactstrap';
import StudentForm from './StudentForm';
import {
  fetchStudent,
  saveStudent,
  fetchAllMallas,
} from '../../../redux/actions/studentsActions';
import { fetchAllUsers } from '../../../redux/actions/usersActions';
import {
  createErrorMessage,
  createSuccessMessage,
  createWarningMessage,
} from '../../../helpers/notification';

class EditStudentContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { loaded: false };
  }

  componentDidMount() {
    this.fetchUserList();
    this.fetchMallaList();
    this.fetchCurrentStudent();
  }

  fetchCurrentStudent = () => {
    const { id, history } = this.props;
    if (id) {
      fetchStudent(id,
        {
          onSuccess: (dto) => {
            const {
              mallaId,
              malla,
              carrera,
              usuarioId,
              nombre,
              apellido,
            } = dto;
            const student = {
              ...dto,
              malla: {
                value: mallaId,
                label: `${malla} - ${carrera}`,
              },
              usuario: {
                value: usuarioId,
                label: `${nombre} ${apellido}`,
              },
            };
            this.setState({ student, loaded: true });
          },
          onError: (error) => {
            if (error && error.status === 404) {
              createErrorMessage('El alumno no existe');
              history.push('/pages/students');
            } else {
              createErrorMessage('Error al intentar cargar los datos del alumno');
            }
          },
        });
    } else {
      this.setState({
        student: {
          id: 0,
          numeroLegajo: 0,
        },
      });
      this.setState({ loaded: true });
    }
  }

  fetchUserList = () => {
    fetchAllUsers({
      onSuccess: (users) => {
        this.setState({ users });
      },
      onError: () => {
        createErrorMessage('Error al intentar cargar los datos de usuarios');
      },
    });
  }

  fetchMallaList = () => {
    fetchAllMallas({
      onSuccess: (mallas) => {
        this.setState({ mallas });
      },
      onError: () => {
        createErrorMessage('Error al intentar cargar los datos de mallas');
      },
    });
  }

  handleSubmit = (values) => {
    const { malla, usuario, numeroLegajo } = values;
    const { value: mallaId } = malla;
    const { value: usuarioId } = usuario;
    const params = {
      ...values,
      usuarioId,
      mallaId,
      numeroLegajo: +numeroLegajo,
    };
    const { history } = this.props;
    saveStudent(params,
      {
        onSuccess: () => {
          createSuccessMessage('Alumno guardado exitosamente');
          history.push('/pages/students');
        },
        onError: (error) => {
          if (error.message) {
            createWarningMessage(error.message);
          } else {
            createErrorMessage('Ocurrió un error al intentar guardar el alumno');
          }
        },
      });
  }

  handleOnBack = () => {
    const { history } = this.props;
    history.goBack();
  }

  render() {
    const { id, history } = this.props;
    const {
      student,
      loaded,
      users,
      mallas,
    } = this.state;

    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className="page-title">
              {id ? 'Editar' : 'Nuevo'} alumno
            </h3>
            <h3 className="page-subhead subhead">
              {id ? 'Modificar ' : 'Ingresa '}
              la informaci&oacute;n del alumno
            </h3>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            {!(loaded && users && mallas)
              ? (<h3 className="page-subhead subhead">Cargando...</h3>)
              : (
                <StudentForm
                  {...student}
                  onSubmit={this.handleSubmit}
                  onBack={this.handleOnBack}
                  initialValues={student}
                  history={history}
                  mallas={mallas}
                  users={users}
                />
              )
            }
          </Col>
        </Row>
      </Container>
    );
  }
}

EditStudentContainer.propTypes = {
  id: PropTypes.string.isRequired,
  history: PropTypes.shape({}).isRequired,
};

export default EditStudentContainer;
